/**
 * SQL operator mapping for query operators
 * Maps abstract query operators to SQL equivalents
 */
export const QUERY_OPERATOR_SQL_MAP = {
    eq: '=',
    ne: '!=',
    gt: '>',
    gte: '>=',
    lt: '<',
    lte: '<=',
    in: 'IN',
    nin: 'NOT IN'
};
//# sourceMappingURL=query-specification.types.js.map